import { MdLocationOn } from 'react-icons/md';
import { BsFillTelephoneFill } from 'react-icons/bs';
import { AiOutlineMessage } from 'react-icons/ai';
import { BsPersonFill } from 'react-icons/bs';

import { User } from '../types/types';

import ProfileImage from './ProfileImage';
import ContactButton from './ContactButton';
import RatingInfo from './RatingInfo';

import rgbHex from 'rgb-hex';
import ServicesIProvide from './ServicesIProvide';
import VerifiedBadge from './VerifiedBadge';
import { IconButton, Tooltip } from '@mui/material';
import { useContext } from 'react';
import AlgoliaContext from '../context/AlgoliaContext';

interface SearchResultsContainerProps {
  user: User
}

const SearchResultsContainer:React.FC<SearchResultsContainerProps> = ({user}) => {

  const {
    isMobile
  } = useContext(AlgoliaContext);

  return (
          <div style={{boxShadow: '0 3px 6px 0 rgba(0, 0, 0, 0.16)'}} className="search_result flex flex-col xl:flex-row md:space-x-[25px] justify-center items-center relative w-[350px] md:w-[669px] xl:w-full md:h-[410px] xl:h-[210px] md:max-xl:space-x-[0] overflow-hidden rounded-[16px] drop-shadow-xl bg-white" key={user.objectID}>
              
              <div className='md:max-xl:mb-4 flex flex-row p-5 md:p-0 md:w-[620px] xl:w-[60%] w-full space-x-[10px] md:space-x-[25px] items-center'>


                <div style={{margin: 0}} className='profile_picture_container'>
                  <a href={"/" + user.filename} className='flex flex-row'>
                    <ProfileImage src={user.photo_file} />
                  </a>
                </div>

                <div className='info_container flex flex-col content-start md:max-xl:w-[380px] w-[405px] md:space-y-4'>
                  <div className='flex flex-col md:space-y-4 '>

                    <div className='flex flex-row justify-start space-x-1 md:space-x-8'>
                      <a href={"/" + user.filename} className={`md:text-[20px] text-[17px] flex flex-row text-[#1da1ed] hover:text-blue-600 gap-5 items-center`}>
                        {user.first_name || user.last_name ? <h1>{user.first_name + ' ' + user.last_name}</h1> : null}
                      </a>
                      {
                        user.verified == "1" ? 
                        <VerifiedBadge />
                        : null
                      }
                    </div>

                    <div className='flex flex-col md:flex-row items-start md:items-center md:space-x-3 text-[15px] items-center md:min-w-[185px]'>
                      {user.company ? <p className={`text-[#0f66a0] font-bold`}>{user.company}</p> : null}
                      {user.city || user.state || user.country_ln ?
                        <div className='flex flex-row items-center space-x-[1px]'>
                          <MdLocationOn className={`text-[#00335f] text-[20px]`} />
                          <p className={`text-[#00a1ed]`}>
                          {user.city ? user.city + (user.state || user.city || user.zip_code || user.country_ln ? ", " : "") : ""}
                          {user.state_ln && (user.city || user.zip_code || user.country_ln ? user.state_ln + ", " : user.state_ln) ? user.state_ln : ""}
                          </p>
                        </div>
                        : null
                      }
                    </div>

                    {/* <div className='flex flex-row'>
                      {
                        user.verified !== null && user.verified !== "0" ?
                          (
                            <div title="verified" className="btn-xs alert-success bold nopad nolpad rmargin inline-block member-search-verified align-middle">
                              <span className="btn-xs novpad bg-success pull-left" style={{ "borderRadius": "3px 0 0 3px;" }}>
                                <i className="fa fa-check"></i>
                              </span>
                              <span className="btn-xs novpad">
                                verified
                              </span>
                            </div>
                          ) : null
                      }
                      <RatingInfo
                        reviews_count={parseInt(user.reviews_count)}
                        reviews_average={parseFloat(user.reviews_average)}
                        google_rating={parseFloat(user.google_rating)}
                        google_user_ratings_total={parseInt(user.google_user_ratings_total)}
                      />
                    </div> */}
                  </div>
                  <div className='hidden md:flex min-h-[90px]'>
                  {
                    user.search_description &&
                    <p className={`text-left text-[15px]`}>{user.search_description}</p>
                  }
                  </div>
                </div>

              </div>

              <div className='md:hidden xl:w-[1px] xl:h-[70%] w-[80%] h-[1px] bg-[#707070]'></div>

              <div className='md:max-xl:px-10 flex flex-row justify-center items-center w-full md:w-full xl:w-[360px] space-x-[25px]'>

                <div className='md:max-xl:!w-[50%] md:max-xl:justify-start md:max-xl:items-start w-[150px] flex flex-col justify-center items-center'>

                  {
                    user.category_names && user.category_names.length > 0 ? 
                    <ServicesIProvide
                      services={user.category_names.split(',')} 
                      filename={user.filename}
                    />
                    : null
                  }

                </div>

                <div className={`md:max-xl:!w-[50%] md:max-xl:h-[auto] h-[210px] w-[130px] md:w-[185px] flex flex-col justify-center items-center space-y-[10px]`} >
                  <ContactButton text="View Listing" href={"/" + user.filename} className={`md:max-xl:!w-full md:max-xl:!min-w-[172px] flex flex-row items-center justify-center text-white text-[12px] md:text-[16px] w-[130px] md:w-[186px] h-[36px] p-[5px] md:p-[10px] rounded-[12px] shadow-md border border-solid bg-[#0066a0]`} />
                  <ContactButton phoneNumber={'(855) 624-3631'} href={"tel:(855) 624-3631"} text="Show Phone Number" className={`md:max-xl:!w-full md:max-xl:!min-w-[172px] flex flex-row items-center justify-center text-[#0066a0] text-[12px] md:text-[16px] w-[130px] md:w-[186px] h-[36px] p-[5px] md:p-[10px] rounded-[12px] shadow-md border border-solid border-[#0066a0] bg-white`} />
                  <ContactButton text="Send Message" href={"/" + user.filename + "/connect"} className={`md:max-xl:!w-full md:max-xl:!min-w-[172px] flex flex-row items-center justify-center text-white text-[12px] md:text-[16px] w-[130px] md:w-[186px] h-[36px] p-[5px] md:p-[10px] rounded-[12px] shadow-md border border-solid bg-[#00A1ED]`} />
                  <a></a>
                </div>

              </div>

              {

                user.highlighted === "1" ?

                <div style={{ zIndex: '10', width: '300px', height: '30px', backgroundColor: '#0f66a0', transform: 'rotate(320deg)', position: 'absolute', top: isMobile ? 20 : 30 , left: isMobile ? -110 : -120, paddingTop: '10px', paddingBottom: '10px' }}>
                  <h1 style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', fontSize: '1rem', textAlign: 'center', color: 'white' }}>Featured</h1>
                </div>

                :

                null               

              }

            </div>
    )
}

export default SearchResultsContainer